import { THttpService } from '@/services/HttpService';

import { TResponseGame } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formatSuccess = (data: any) => {
  return {
    title: 'Sucesso',
    content: `<p>${data.message}</p>`,
  };
};

const formatError = () => {
  return {
    title: 'Erro',
    content: '<p>Desculpe, não conseguimos completar a requisição.</p>',
  };
};

export const optinGame = async (
  api: THttpService,
  memberNumber: string,
): Promise<TResponseGame> => {
  const path = '/game';

  const data = { memberNumber };
  try {
    const response = await api.put(path, data);
    const result = { message: response.data.message };
    return formatSuccess(result);
  } catch (error) {
    return formatError();
  }
};

export const readGame = async (
  api: THttpService,
  idGame: number,
): Promise<TResponseGame> => {
  const path = '/v1/read';
  const data = { idGame };
  try {
    const response = await api.put(path, data);
    const result = { message: response.data.message };
    return formatSuccess(result);
  } catch (error) {
    return formatError();
  }
};
